import { useLazyQuery, useQuery } from "@apollo/client";
import {
  BestSellingSiteProductsQuery,
  BestSellingSiteProductsQueryVariables,
} from "../../../__generated__/BestSellingSiteProductsQuery";
import { BEST_SELLING_SITE_PRODUCTS } from "../scans.queries";

export const useBestSellingProducts = (
  variables: BestSellingSiteProductsQueryVariables
) => {
  return useQuery<
    BestSellingSiteProductsQuery,
    BestSellingSiteProductsQueryVariables
  >(BEST_SELLING_SITE_PRODUCTS, { variables });
};
export const useLazyBestSellingProducts = () => {
  return useLazyQuery<BestSellingSiteProductsQuery>(BEST_SELLING_SITE_PRODUCTS);
};
